<div class="mb-4 flex justify-between">
  <h1 class="text-primary text-2xl font-bold" i18n="@@pharmaciesTitle">Pharmacies</h1>
  <a
    routerLink="/user/pharmacies/new-request"
    class="bg-primary hover-bg-primary-hover flex items-center justify-center gap-1 rounded-[8px] px-[8px] py-[4px] text-[14px] font-[500] text-[white] hover:cursor-pointer">
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
    </svg>
    <span i18n="@@pharmaciesRegisterNew">Register New Pharmacy</span>
  </a>
</div>
